<lib-prod-grid
  [title]="prodGridTitle"
  [icon]="'dataset'"
  [columns]="prodGridColumns"
  [class]="'distributor-tab'"
  [isAddButtonShown]="true"
  [isRemoveButtonShown]="true"
  [isAddButtonDisabled]="prodGridToolbarButtonsStatus.isAddButtonDisabled.disabled"
  [isRemoveButtonDisabled]="prodGridToolbarButtonsStatus.isRemoveButtonDisabled.disabled"
  [matTableDataSource]="matTableDataSource"
  [inputAction$]="inputAction$"
  (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
